function getAuthHeaders() {
    const token: any = localStorage.getItem('ims-token') || ''
    return {
        'x-api-key': 'oac-connect-service',
        'Content-Type': 'application/json',
        'Authorization': token ? JSON.parse(token) : ''
    }
}

export default getAuthHeaders